$('.send-feedback-feeling').click(function (e) {
	var $button = $('.send-feedback-feeling')
	var $form = $button.parent()
	$form.find('[name=video]').val(location.hash.substr(1))
	$.post('feedback/feeling', $form.serialize())
	.done(function (data) {
		if (data.indexOf('good') !== -1) {
		}
		else {
		}
	})
	.fail(function (data) {
	})
	.always(function () {
		$form.find('textarea').val('')
		alert('Thank you!')
	})
})
$('.send-feedback-series').click(function (e) {
	var $button = $('.send-feedback-series')
	var $form = $button.parent()
	$.post('feedback/series', $form.serialize())
	.done(function (data) {
		if (data.indexOf('good') !== -1) {
		}
		else {
		}
	})
	.fail(function (data) {
	})
	.always(function () {
		$form.find('textarea').val('')
		alert('Thank you!')
	})
	e.preventDefault()
})
